import { render, staticRenderFns } from "./SideBySideEditor.vue?vue&type=template&id=178e4cb4"
import script from "./SideBySideEditor.vue?vue&type=script&lang=js"
export * from "./SideBySideEditor.vue?vue&type=script&lang=js"
import style0 from "./SideBySideEditor.vue?vue&type=style&index=0&id=178e4cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports